import 'regenerator-runtime/runtime';
import ExcelJS from 'exceljs';
import JSZip from 'jszip';

const fruits = ['Apple', 'Banana', 'Orange', 'Mango', 'Strawberry', 'Kiwi', 'Pineapple', 'Grapefruit', 'Watermelon', 'Peach'];


export async function getSampleWorkbook() {
  // Create a new workbook
  const workbook = createSampleWorkbook();

  const url = await getWorkbookURL(workbook);
  return url;
}


export function newWorkbook() {
  return new ExcelJS.Workbook();
}


export function createSampleWorkbook(sheets=3, rows=10) {
  // Create a new workbook
  const workbook = new ExcelJS.Workbook();

  // Add some sheets and data to the workbook
  for (let i = 1; i <= sheets; i++) {
    const worksheet = workbook.addWorksheet(`Sheet ${i}`);

    worksheet.columns = [
      { header: 'ID', key: 'id', width: 10 },
      { header: 'Name', key: 'name', width: 30 },
    ];

    for (let j = 1; j <= rows; j++) {
      worksheet.addRow({
        id: Math.floor(Math.random() * 1000),
        name: fruits[Math.floor(Math.random() * fruits.length)],
      });
    }
  }

  return workbook;
}


export async function getWorkbookURL(workbook) {
  // Convert workbook to blob
  const blob = await workbookToBLOB(workbook);

  // Create a URL from the blob
  return URL.createObjectURL(blob);
}


export async function workbookToBLOB(workbook) {
  // Write workbook to a buffer
  const buffer = await workbook.xlsx.writeBuffer();

  // Create a blob from the buffer
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  return blob;
}

// Function to create a ZIP file from given CSV data
export function createCSVZip(csvFiles) {
  const zip = new JSZip();
  // Add CSV files to the ZIP
  csvFiles.forEach(file => {
    zip.file(file.name, file.content);
  });
  return zip;
}

// Function to generate a downloadable URL from a ZIP object
export async function getZipFileURL(zip) {
  try {
    const zipBlob = await zip.generateAsync({ type: 'blob' });
    const url = URL.createObjectURL(zipBlob);
    return url;
  } catch (error) {
    console.error('Error generating ZIP file:', error);
    throw error;
  }
}

// Function to create a CSV file from given CSV data
export function createCSVFile(csvFile) {
  const file = new Blob([csvFile.content], { type: 'text/csv' });
  console.log('file', file);
  return file;
}

// Function to generate a downloadable URL from the CSV file
export function getCSVFileURL(csvFile) {
  try {
    const fileBlob = createCSVFile(csvFile);
    const url = URL.createObjectURL(fileBlob);
    return url;
  } catch (error) {
    console.error('Error generating CSV file URL:', error);
    throw error;
  }
}
